import { addRtkQueryBridges, buildSlice, CommonState } from '~libs/reduxUtils';
import { Worker } from '~weekly-planner/lib/common';

import { typePrefix, visualiseApi } from '~weekly-planner/actions/visualise';

const initialState: CommonState<Worker> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<Worker>, Worker>(typePrefix, initialState, {
  customActions: {
    clearSingleRow: (state, action) => {
      state.rows = state.rows.filter((worker) => String(worker?.id) !== String(action.payload));
    },
  },
  extraReducers: (builder) => {
    addRtkQueryBridges<CommonState<Worker>, Worker>(builder, [
      {
        endpoint: visualiseApi.endpoints.visualiseDistance,
        mode: 'detail',
        apply: (state, payload) => {
          const newWorker = payload?.data;
          if (!newWorker) return;
          const existingWorkerIndex = state.rows.findIndex((worker) => worker?.id === newWorker?.id);
          if (existingWorkerIndex >= 0) {
            state.rows[existingWorkerIndex] = newWorker;
          } else {
            state.rows.push(newWorker);
          }
          state.hasLoaded = true;
        },
      },
    ]);
  },
});

export const { clear, clearSingleRow, updateParams } = slice.actions;
export default slice.reducer;
